module.exports = __webpack_public_path__ + "static/media/recommendations-cover-2.635a2112.png";